<div class="app-body bg-[#05013d] w-[100vw] h-[100vh]">

    <div class="app-content h-full w-full bg-white overflow-auto">

        @if (!hideHeader()) {
            <app-header></app-header>
        }

        <main class="main-content" role="main">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>

@if (dotLoadingServices.isLoading()) {
    <app-dot-animation [isLoading]="isLoading()"></app-dot-animation>
}

<div class="fixed top-6 z-[1001] w-full max-w-sm sm:right-40 flex flex-col gap-4">
    @for (notification of notifications(); track notification.id) {
        <app-notification-alert
                [type]="notification.type"
                [message]="notification.message"
                [isLeaving]="notification.isLeaving"
                (close)="notificationService.startLeaveAnimation(notification.id)"
                class="transform transition-all duration-500 ease-in-out">
        </app-notification-alert>
    }
</div>